import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import envVarsProvider from '@/utils/envVars/envVars';

const applicationId = envVarsProvider.DD_RUM_APPLICATION_ID.val;
const clientToken = envVarsProvider.DD_RUM_CLIENT_TOKEN.val;
const tracingDisabled = envVarsProvider.UI_TRACING_DISABLED.val;

if ( !tracingDisabled && applicationId && clientToken ) {
  datadogRum.init( {
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: envVarsProvider.DD_RUM_SERVICE.val || 'studio-ui',
    env: envVarsProvider.DD_RUM_ENV.val || undefined,
    version: envVarsProvider.APP_VERSION.val,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [ reactPlugin( { router: true } ) ]
  } );
}
